/**
 * 详情页组件
 * Created at 2021-10-02 12:51
 * @author teapot
 */
import { useEffect, useReducer } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { useAppSelector, useAppDispatch } from "../../app/hooks";
import { RootState } from "../../app/store";
import Config from "../../config";
import { detailsAsync, setDetails } from "../../store/HomeStore";
import "./index.css";
import { Divider, Image } from "antd";
// import  until from '../../../until.js'
const urlParams = new URL(window.location.href);
const pathname = urlParams?.pathname;
// console.log(pathname);

const Details = () => {
  const location = useLocation<any>();
  const history = useHistory();
  const { id } = useParams<any>();
  let newspaper;
  const { detailsContent, detailsImgs, detailsContent_m } = useAppSelector(
    (state: RootState) => state.home
  );
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setDetails());

    if (
      location.state &&
      !(location.state.uuid && location.state.url && location.state.methods)
    ) {
      history.goBack();
      return;
    }

    if (id && !location.state) {
      let state = JSON.parse(window.atob(id));
      dispatch(
        detailsAsync({
          url: state.url,
          uuid: state.uuid,
          methods: state.methods,
          video: state.video,
          memberImg: decodeURIComponent(state.img),
          memberName: decodeURIComponent(state.name),
          education: decodeURIComponent(state.education),
          postion: decodeURIComponent(state.position),
          pdf: state.pdf,
          info: state.info,
          newstime: decodeURIComponent(state.newstime),
        })
      );
      return;
    }

    dispatch(
      detailsAsync({
        url: location.state.url,
        uuid: location.state.uuid,
        methods: location.state.methods,
        video: location.state.video,
        memberImg: location.state?.memberImg,
        memberName: location.state?.memberName,
        pdf: location.state?.pdf,
        education: location.state?.education,
        postion: location.state?.position,
        info: location.state?.info,
        newstime: location.state?.newstime,
      })
    );
  }, [dispatch, history, location.state, id]);

  return (
    <div className="details details-width">
      {/* 人物简介 */}
      {pathname == "/commentary/member_date_comment" ? (
        <div className="detail-left-introduction phone-menber">
          <Image
            style={{ marginTop: "20px" }}
            src={`${Config.MAIN_URL}${location.state.memberImg}`}
            width="80%"
            height="328px"
          />
          <div className="member-name">
            {location.state.memberName}{" "}
            <span className="member-education">{location.state.education}</span>
          </div>
          {location.state.position &&
            location.state.position.map((item: any, index: any) => {
              return <div className="item-position">{item}</div>;
            })}
        </div>
      ) : null}

      <div className="detail-right-introduction">
        {
          <div className="detail-nav">
            <div>
              <div className="detail-nav-left">
                {/* {console.log('sca', location.state.video)} */}

                {pathname == "/newsroom/press-release/date_pressreleasetitle_tc"
                  ? localStorage.getItem("i18nextLng") === "zh-HK"
                    ? (newspaper = "新聞稿")
                    : "新闻稿"
                  : pathname == "/commentary/member_date_comment"
                  ? localStorage.getItem("i18nextLng") === "zh-HK"
                    ? (newspaper = "時事評論")
                    : "时事评论"
                  : localStorage.getItem("i18nextLng") === "zh-HK"
                  ? (newspaper = "最新活動")
                  : "最新活动"}
                {location.state && location.state.newstime && (
                  <div className="newstime">{location.state.newstime}</div>
                )}
              </div>
            </div>
            <div className="detail-nav-right">
              <span>＜</span>
              <span
                onClick={() => {
                  window.history.back();
                }}
              >
                {" "}
                {localStorage.getItem("i18nextLng") === "zh-HK"
                  ? "上一頁"
                  : "上一页"}{" "}
              </span>
            </div>
          </div>
        }
        {location.state && location.state.title ? (
          <div className="details-title details-title-size">
            {location.state.title}
          </div>
        ) : null}
        {(location.state && !location.state.bottom) || detailsContent ? (
          <>
            <div
              className="detail-content"
              dangerouslySetInnerHTML={{ __html: detailsContent }}
            ></div>
            <div className="details-placeholder" />
          </>
        ) : null}

        {detailsImgs.map((item, index) => {
          console.log("adawd" + `${Config.MAIN_URL}${item.url}`);
          return (
            <Image
              src={`${Config.MAIN_URL}${item.url}`}
              alt={item.name + ""}
              preview={false}
              key={index}
              width={"100%"}
            />
          );
        })}
        {<hr></hr>}
        <div className="news-download ">
          {location.state && location.state.pdf ? (
            <a
              className="offsetY"
              href={`${Config.MAIN_URL}${location.state.pdf}`}
            >
              下載新聞稿
            </a>
          ) : null}
          {pathname &&
          pathname == "/newsroom/press-release/date_pressreleasetitle_tc" &&
          location.state &&
          location.state.info &&
          location.state.info ? (
            <span className="offsetX">
              {localStorage.getItem("i18nextLng") === "zh-HK"
                ? `傳媒查詢：如對我們的倡議和所關注的議題作更深入的了解，歡迎致電${location.state.info.phone}或電郵至 ${location.state.info.email} 與我們聯絡`
                : `传媒查询：如对我们的倡议和所关注的议题作更深入的了解，欢迎致电${location.state.info.phone} 或电邮至${location.state.info.email}与我们联络`}
            </span>
          ) : null}
        </div>

        {location.state && location.state.bottom ? (
          <>
            <div className="details-placeholder" />

            {detailsContent_m ? (
              <>
                <div
                  className="details-pc"
                  dangerouslySetInnerHTML={{ __html: detailsContent }}
                ></div>
                <div
                  className="details-phone"
                  dangerouslySetInnerHTML={{ __html: detailsContent_m }}
                ></div>
              </>
            ) : (
              <div
                className="details-pc"
                dangerouslySetInnerHTML={{ __html: detailsContent }}
              ></div>
            )}
          </>
        ) : null}
        {/* video功能 */}

        {location.state &&
        location.state.video &&
        location.state.video !== "undefined" ? (
          <div>
            <div className="videoActivy">
              {localStorage.getItem("i18nextLng") === "zh-HK"
                ? "活動剪影"
                : "活动剪影"}
            </div>
            <video controls width={"100%"}>
              <source
                src={`${Config.MAIN_URL}${location.state.video}`}
                type="video/mp4"
              />
            </video>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default Details;
